import { useRoutes } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import AppProviders from './context/AppProviders';
import router from './router/router';
import { initMonitoring } from './services/monitoringServices/initMonitoring';

initMonitoring();

function App() {
  const content = useRoutes(router);

  return (
    <AppProviders>
      <div>{content}</div>
    </AppProviders>
  );
}

export default App;
